import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ClaimedBusinessProfile from './components/ClaimedBusinessProfile'
import api from 'api'
// import GradientCircularProgress from 'components/Common/GradientCircularProgress'
import { styled } from '@mui/material/styles'
import routes from 'routes'
import { useNavigate } from 'react-router-dom'
import Dialog from 'components/Common/Dialog'
import Button from 'components/Common/Button'
import { SECONDARY_BUTTON } from 'themes/theme'
import I18n from 'i18next'

import './styles.css'
import UnclaimedUser from './components/UnclaimedUser'

const ProfileCardContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  padding: '40px 35px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}))

function BusinessProfileCard() {
  const [businessData, setBusinessData] = useState({})
  const [businessProfileCompletion, setBusinessProfileCompletion] = useState(0)
  const [userProfileCompletion, setUserProfileCompletion] = useState(0)
  const user = useSelector(state => state.userReducer.user)
  const [isDialogOpen, setIsDialogOpen] = useState({ profile: false, business: false })
  const navigate = useNavigate()

  const setDialog = useCallback(value => setIsDialogOpen(value), [setIsDialogOpen])

  useEffect(() => {
    if (!user) return
    fetchAndSetData()
  }, [user])

  const onClickMyAccount = () => {
    navigate(routes.myAccount)
  }

  const onClickMyBusiness = () => {
    navigate(routes.myBusiness)
  }

  const fetchAndSetData = async () => {
    const data = await api.getDashboardInfo()
    if (data?.business_info?.business_profile_completion)
      setBusinessProfileCompletion(parseInt(data?.business_info?.business_profile_completion))
    if (data?.user_info?.profile_completion) setUserProfileCompletion(parseInt(data?.user_info?.profile_completion))

    if (data.business_info?.claimed_business_details) {
      setBusinessData(data.business_info?.claimed_business_details)
      return
    }
  }

  return (
    <>
      <ProfileCardContainer>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: '250px',
          }}
        >
          {businessData?.isClaimed ? (
            <ClaimedBusinessProfile
              businessData={businessData}
              userProfileCompletion={userProfileCompletion}
              businessProfileCompletion={businessProfileCompletion}
            />
          ) : (
            <UnclaimedUser
              businessData={businessData}
              userProfileCompletion={userProfileCompletion}
              businessProfileCompletion={businessProfileCompletion}
            />
          )}
        </Box>

        {isDialogOpen.profile && (
          <Dialog
            show={isDialogOpen}
            setShow={() => setDialog({ ...isDialogOpen, profile: false })}
            title={I18n.t('homePage.increaseYourUserProfilePercentage')}
            content={
              <Box>
                <Typography variant="body1" color="primary">
                  {I18n.t('homePage.theFollowingItems')}
                </Typography>
                <ul className="percentage-dialog" style={{ marginTop: '30px' }}>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.firstAndLastName')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.businessTitle')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.address')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.profilePicture')}
                    </Typography>
                  </li>
                </ul>

                <Box marginTop="50px">
                  <Button
                    type={SECONDARY_BUTTON}
                    sx={{ width: '260px', marginRight: '20px' }}
                    onClick={() => {
                      setIsDialogOpen(false)
                    }}
                  >
                    Close
                  </Button>
                  <Button sx={{ width: '260px' }} onClick={onClickMyAccount}>
                    Update User Profile
                  </Button>
                </Box>
              </Box>
            }
          />
        )}

        {isDialogOpen.business && (
          <Dialog
            show={isDialogOpen}
            setShow={() => setDialog({ ...isDialogOpen, business: false })}
            title={I18n.t('homePage.increaseYourClaimedBusinessPercentage')}
            content={
              <Box>
                <Typography variant="body1" color="primary">
                  {I18n.t('homePage.theFollowingItems')}
                </Typography>
                <ul className="percentage-dialog" style={{ marginTop: '30px' }}>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.updateTheProfileTab')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.linkSocialMediaAccount')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.enterBusinessData')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.uploadYourBusinessLogo')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.addOnePerson')}
                    </Typography>
                  </li>
                </ul>

                <Box marginTop="50px">
                  <Button
                    type={SECONDARY_BUTTON}
                    sx={{ width: '285px', marginRight: '20px' }}
                    onClick={() => {
                      setIsDialogOpen(false)
                    }}
                  >
                    Close
                  </Button>
                  <Button sx={{ width: '285px' }} onClick={onClickMyBusiness}>
                    Update Claimed Business
                  </Button>
                </Box>
              </Box>
            }
          />
        )}
      </ProfileCardContainer>
    </>
  )
}

export default React.memo(BusinessProfileCard)
